// Small utilities for Embers

export function formatRelative(iso: string): string {
  const d = new Date(iso)
  const now = new Date()
  const diff = (now.getTime() - d.getTime()) / 1000
  if (diff < 60) return 'just now'
  if (diff < 3600) return Math.floor(diff / 60) + 'm ago'
  if (diff < 86400) return Math.floor(diff / 3600) + 'h ago'
  return Math.floor(diff / 86400) + 'd ago'
}

export function generateEmberSeed(): { seed: string; hash: string } {
  // 32-byte-ish high entropy seed the user can write down for recovery
  const bytes = new Uint8Array(24)
  crypto.getRandomValues(bytes)
  const seed = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('')
  // Simple SHA-256 of the seed for the server (never send the seed itself)
  return { seed, hash: '' } // hash computed async in identity layer
}

export async function hashSeed(seed: string): Promise<string> {
  const enc = new TextEncoder()
  const data = enc.encode(seed + '|embers|v1')
  const buf = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('')
}

export function getStoredSeed(): string | null {
  return localStorage.getItem('embers:seed')
}

export function storeSeed(seed: string) {
  localStorage.setItem('embers:seed', seed)
}

export function clearLocal() {
  localStorage.removeItem('embers:seed')
  localStorage.removeItem('embers:userId')
}

export function cn(...classes: (string | false | null | undefined)[]) {
  return classes.filter(Boolean).join(' ')
}
